import { add, compare, isNegative, isPositive, isZero, subtract, } from '@aeris/money';
import { ZERO_AMOUNT, outstanding } from "./entities.js";
export const checkSettlement = (entry, amounts) => {
    if (entry.status === 'cancelled') {
        return { ok: false, refusal: { reason: 'entry-cancelled' } };
    }
    if (!isPositive(amounts.amount)) {
        return { ok: false, refusal: { reason: 'amount-not-positive' } };
    }
    if (isNegative(amounts.interestAmount) ||
        isNegative(amounts.fineAmount) ||
        isNegative(amounts.discountAmount)) {
        return { ok: false, refusal: { reason: 'adjustment-negative' } };
    }
    const rest = outstanding(entry);
    if (isZero(rest)) {
        return { ok: false, refusal: { reason: 'entry-already-settled' } };
    }
    if (compare(amounts.amount, rest) > 0) {
        return {
            ok: false,
            refusal: { reason: 'over-settlement', outstanding: rest },
        };
    }
    const gross = add(add(amounts.amount, amounts.interestAmount), amounts.fineAmount);
    const paidAmount = subtract(gross, amounts.discountAmount);
    if (isNegative(paidAmount)) {
        return { ok: false, refusal: { reason: 'discount-exceeds-total' } };
    }
    const settledAmountAfter = add(entry.settledAmount, amounts.amount);
    const outstandingAfter = subtract(entry.amount, settledAmountAfter);
    return {
        ok: true,
        check: {
            paidAmount,
            settledAmountAfter,
            outstandingAfter: isNegative(outstandingAfter)
                ? ZERO_AMOUNT
                : outstandingAfter,
            closesEntry: !isPositive(outstandingAfter),
        },
    };
};
/**
 * Undoing a baixa without erasing it.
 *
 * The reversal is a new row. The title's `settledAmount` comes back down and
 * its status returns to `open` — a settled title that is un-settled is ordinary
 * (a cheque bounced, a PIX was reversed, the wrong título was picked from the
 * list), and the trail must show both events rather than the second one only.
 */
export const checkReversal = (entry, settlement) => {
    if (entry.status === 'cancelled') {
        return { ok: false, refusal: { reason: 'entry-cancelled' } };
    }
    if (settlement.reversesSettlementId !== null) {
        return { ok: false, refusal: { reason: 'is-a-reversal' } };
    }
    if (settlement.reversedByCount > 0) {
        return { ok: false, refusal: { reason: 'already-reversed' } };
    }
    const after = subtract(entry.settledAmount, settlement.amount);
    const settledAmountAfter = isNegative(after) ? ZERO_AMOUNT : after;
    return {
        ok: true,
        check: {
            settledAmountAfter,
            statusAfter: compare(settledAmountAfter, entry.amount) >= 0 ? 'settled' : 'open',
        },
    };
};
export const checkCancellation = (entry) => {
    if (entry.status === 'cancelled') {
        return { ok: false, refusal: { reason: 'already-cancelled' } };
    }
    if (isPositive(entry.settledAmount)) {
        return { ok: false, refusal: { reason: 'has-settlements' } };
    }
    return { ok: true };
};
//# sourceMappingURL=settlement.js.map